module.exports = __webpack_public_path__ + "static/media/exit.cf1b98c7.svg";